import React from 'react';
import { Button } from '@/components/ui/button';
import { FileText, Activity, AlertTriangle, Pencil } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function QuickActionBar({ participantId, accessControl, canViewCharts }) {
  const navigate = useNavigate();
  const perms = accessControl || {};

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="quick-action-bar">
      <Button variant="outline" size="sm" className="h-7 text-xs gap-1" onClick={() => navigate(`/participants/${participantId}?tab=notes`)} data-testid="quick-add-note">
        <FileText className="w-3 h-3" /> Add Note
      </Button>
      {canViewCharts && (
        <Button variant="outline" size="sm" className="h-7 text-xs gap-1" onClick={() => navigate(`/participants/${participantId}?tab=charts`)} data-testid="quick-add-chart">
          <Activity className="w-3 h-3" /> Charts
        </Button>
      )}
      <Button variant="outline" size="sm" className="h-7 text-xs gap-1" onClick={() => navigate(`/participants/${participantId}?tab=risks`)} data-testid="quick-add-incident">
        <AlertTriangle className="w-3 h-3" /> Incidents
      </Button>
      {perms.can_edit && (
        <Button variant="outline" size="sm" className="h-7 text-xs gap-1" onClick={() => navigate(`/participants/${participantId}?tab=overview`)} data-testid="quick-edit-profile">
          <Pencil className="w-3 h-3" /> Edit
        </Button>
      )}
    </div>
  );
}
